import base58 from 'bs58';

let connection: any;
export const SolMainAddress = '11111111111111111111111111111111';
export const mockSolEvmChainId = 501;
export const solDecimals = 9;
export const solTokenName = 'SOL';
export const solEndpoint =
  'https://rpc.ankr.com/solana/ac79e83cf02a544dbb9b3f4c5d5478b2510b921e7d5739ded8791a932e8de0a6';
export const solScanUrl = 'https://solscan.io/tx/';
export function getConnection() {
  if (connection) {
    return connection;
  }
  (async function() {
    const solanaWeb3 = await import('@solana/web3.js');
    // connection = new Connection(solEndpoint, 'recent')
    connection = new solanaWeb3.Connection(solEndpoint, 'finalized');
  })();
  return connection;
}

export async function getSolFees() {
  try {
    const conn = getConnection();
    const { feeCalculator } = await conn.getRecentBlockhash();
    return {
      totalFee: feeCalculator.lamportsPerSignature.toString() as string,
    };
  } catch (e) {
    return { totalFee: '0' };
  }
}

export async function sendSolTx(
  fromAddress: string,
  toAddress: string,
  amount: bigint, // bigint number
  mintAddress?: string
) {
  try {
    getConnection();
    const solanaWeb3 = await import('@solana/web3.js');
    const tx = new solanaWeb3.Transaction();
    const PublicKey = solanaWeb3.PublicKey;
    const fromPublicKey = new PublicKey(fromAddress);
    const toPublicKey = new PublicKey(toAddress);
    if (!tx.feePayer) {
      tx.feePayer = fromPublicKey;
    }
    if (mintAddress) {
      const tokenPublicKey = new PublicKey(mintAddress);
      tx.recentBlockhash = (
        await connection.getRecentBlockhash('max')
      ).blockhash;
      const solanaSpl = await import('@solana/spl-token');
      tx.add(
        solanaSpl.createTransferInstruction(
          tokenPublicKey,
          toPublicKey,
          fromPublicKey,
          amount
        )
      );
    } else {
      tx.recentBlockhash = (
        await connection.getRecentBlockhash('max')
      ).blockhash;
      tx.add(
        solanaWeb3.SystemProgram.transfer({
          fromPubkey: fromPublicKey,
          toPubkey: toPublicKey,
          lamports: amount,
        })
      );
    }
    const txHex = tx
      .serialize({ requireAllSignatures: false, verifySignatures: false })
      .toString('hex');
    return txHex;
  } catch (e) {
    return null;
  }
}

export const getSolTokenDetail = async (mintAddress: string) => {
  try {
    getConnection();
    const TOKEN_LIST_URL =
      'https://raw.githubusercontent.com/solana-labs/token-list/main/src/tokens/solana.tokenlist.json';
    const response = await fetch(TOKEN_LIST_URL);
    const tokenList = await response.json();
    const tokenDetail = tokenList.tokens.find(
      (token: any) => token.address === mintAddress
    );
    if (tokenDetail) {
      console.log('Token Symbol:', tokenDetail.symbol);
      console.log('Token Name:', tokenDetail.name);
      console.log('Token Decimals:', tokenDetail.decimals);
      return {
        symbol: tokenDetail.symbol,
        decimals: tokenDetail.decimals,
      };
    } else {
      console.log('Token not found in Token List');
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

async function getTokenAmount(client: any, mint: any, owner: any) {
  const solanaSpl = await import('@solana/spl-token');
  const tokenAccount = await solanaSpl.getAssociatedTokenAddress(mint, owner);

  const info = await client.getAccountInfo(tokenAccount);
  if (info == null) {
    return null;
  } else {
    return await client.getTokenAccountBalance(tokenAccount);
  }
}
export async function getSolTokenAccount(client: any, mint: any, owner: any) {
  const solanaSpl = await import('@solana/spl-token');
  const tokenAccount = await solanaSpl.getAssociatedTokenAddress(mint, owner);

  return await client.getAccountInfo(tokenAccount);
}
export const getSolBalance = async ({
  address,
  token,
}: {
  address: string | undefined;
  token: string | undefined;
}) => {
  if (address) {
    const PublicKey = (await import('@solana/web3.js')).PublicKey;
    if (token) {
      const connection = getConnection();
      const owner = new PublicKey(address);
      const mint = new PublicKey(token);

      const tokenAccount = await getTokenAmount(connection, mint, owner);

      if (tokenAccount == null) {
        return {
          amount: BigInt(0),
          token,
          format: '0',
          decimals: undefined,
        };
      } else {
        return {
          amount: BigInt(tokenAccount.value.amount),
          format: tokenAccount.value.uiAmountString,
          decimals: tokenAccount.value.decimals,
          token,
        };
      }
    } else {
      const connection = getConnection();
      const publicKey = new PublicKey(address);
      const balance = await connection.getBalance(publicKey);
      if (!balance) {
        return {
          balance: '0',
          formatted: '0',
        };
      }
      const solBalance = {
        balance: '' + balance,
        formatted: '' + balance / 10 ** 9,
      };
      return solBalance;
    }
  }
  return undefined;
};

function getInstructions(data: any) {
  let instruction;
  (async function() {
    const solanaWeb3 = await import('@solana/web3.js');
    const PublicKey = solanaWeb3.PublicKey;
    instruction = new solanaWeb3.TransactionInstruction({
      programId: new PublicKey(data.programId),
      data: Buffer.from(data.data),
      keys: [],
    });
    for (let j = 0; j < data.keys.length; j++) {
      instruction.keys.push({
        pubkey: new PublicKey(data.keys[j].pubkey),
        isSigner: data.keys[j].isSigner,
        isWritable: data.keys[j].isWritable,
      });
    }
  })();
  return instruction;
}

// @ts-ignore
export const ToSerializeTransaction = async (data: any) => {
  const SolanaWeb3 = await import('@solana/web3.js');
  const PublicKey = SolanaWeb3.PublicKey;
  const txMsg = new SolanaWeb3.TransactionMessage({
    recentBlockhash: data.tx.recentBlockhash,
    payerKey: new PublicKey(data.tx.from),
    instructions: [],
  });

  for (let i = 0; i < data.tx.instructions.length; i++) {
    txMsg.instructions.push(getInstructions(data.tx.instructions[i]));
  }

  if (data.tx && data.tx.txType == 'LEGACY') {
    const tx = SolanaWeb3.Transaction.populate(txMsg.compileToLegacyMessage());

    data.tx.signatures.forEach((signature: any) => {
      tx.addSignature(
        new PublicKey(signature.publicKey),
        Buffer.from(signature.signature)
      );
    });
    // tx.message.recentBlockhash = recentBlockhash
    return Buffer.from(tx.serialize({ requireAllSignatures: false })).toString(
      'hex'
    );
  } else if (data.tx && data.tx.txType == 'VERSIONED') {
    const tx = SolanaWeb3.VersionedTransaction.deserialize(
      data.tx.serializedMessage
    );
    // const tx = new VersionedTransaction(data.tx.serializedMessage)
    // data.tx.signatures.forEach(signature => {
    //     tx.addSignature(new PublicKey(signature.publicKey), Buffer.from(signature.signature))
    // });
    // tx.feePayer = new PublicKey(data.tx.from)

    return Buffer.from(tx.serialize()).toString('hex');
  }
};

export async function getSendSplToken(
  mint: string | undefined,
  from: string | undefined,
  to: string | undefined,
  amount: bigint | undefined
) {
  const connection = getConnection();
  const SolanaWeb3 = await import('@solana/web3.js');
  const PublicKey = SolanaWeb3.PublicKey;
  const solanaSpl = await import('@solana/spl-token');

  const mintPublicKey = mint && new PublicKey(mint);
  const fromPublicKey = from && new PublicKey(from);
  const toPublicKey = to && new PublicKey(to);

  if (mintPublicKey && fromPublicKey && toPublicKey && amount) {
    const fromATA = await solanaSpl.getAssociatedTokenAddress(
      mintPublicKey,
      fromPublicKey
    );

    const fromInfo = await connection.getAccountInfo(fromATA);

    if (fromInfo == null) {
      console.warn('from not token accmount');
      return null;
    }
    const fromTokenAccount = await connection.getTokenAccountBalance(fromATA);
    if (fromTokenAccount.value.amount < amount) {
      return null;
    }

    const transaction = new SolanaWeb3.TransactionMessage({
      payerKey: fromPublicKey,
      recentBlockhash: (await connection.getLatestBlockhash()).blockhash,
      instructions: [],
    });

    const toATA = await solanaSpl.getAssociatedTokenAddress(
      mintPublicKey,
      toPublicKey
    );
    const toInfo = await connection.getAccountInfo(toATA);
    const TOKEN_PROGRAM_ID = new PublicKey(
      'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA'
    );

    if (toInfo == null) {
      const ASSOCIATED_TOKEN_PROGRAM_ID = new PublicKey(
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'
      );
      transaction.instructions.push(
        solanaSpl.createAssociatedTokenAccountInstruction(
          fromPublicKey,
          toATA,
          toPublicKey,
          mintPublicKey,
          TOKEN_PROGRAM_ID,
          ASSOCIATED_TOKEN_PROGRAM_ID
        )
      );
    }

    transaction.instructions.push(
      solanaSpl.createTransferCheckedInstruction(
        fromATA,
        mintPublicKey,
        toATA,
        fromPublicKey,
        amount,
        fromTokenAccount.value.decimals,
        [],
        TOKEN_PROGRAM_ID
      )
    );

    const versionedTransaction = new SolanaWeb3.VersionedTransaction(
      transaction.compileToV0Message()
    );

    // return base58.encode(versionedTransaction.serialize())
    return Buffer.from(versionedTransaction.serialize()).toString('hex');
  }

  return undefined;
}
export async function sendTransaction(rawTransaction: string) {
  getConnection();
  const result = await connection.sendRawTransaction(
    Buffer.from(rawTransaction, 'hex')
  );
  return result;
}
